// src/modules/Admin/pages/LinkedIn/LinkedInCallback.js
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { handleOAuthCallback, getProfile } from '../../../../services/linkedinService';
import { FaLinkedin, FaCheckCircle, FaTimesCircle, FaSpinner } from 'react-icons/fa';

const Container = styled.div`
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #0077B5 0%, #005582 100%);
  padding: 24px;
`;

const Card = styled.div`
  background: white;
  border-radius: 16px;
  padding: 48px;
  max-width: 400px;
  width: 100%;
  text-align: center;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
`;

const Icon = styled.div`
  font-size: 64px;
  margin-bottom: 24px;
  color: ${props => props.$status === 'success' ? '#10b981' : props.$status === 'error' ? '#ef4444' : '#0077B5'};

  svg {
    animation: ${props => props.$loading ? 'spin 1s linear infinite' : 'none'};
  }

  @keyframes spin {
    from { transform: rotate(0deg); }
    to { transform: rotate(360deg); }
  }
`;

const Title = styled.h1`
  font-size: 24px;
  font-weight: 600;
  color: #111;
  margin-bottom: 12px;
`;

const Message = styled.p`
  font-size: 16px;
  color: #666;
  line-height: 1.6;
`;

const CloseButton = styled.button`
  margin-top: 24px;
  padding: 12px 32px;
  background: #0077B5;
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: all 200ms;

  &:hover {
    background: #005582;
  }
`;

const LinkedInCallback = () => {
  const [status, setStatus] = useState('loading'); // loading, success, error
  const [message, setMessage] = useState('Processando autenticacao...');

  useEffect(() => {
    processCallback();
  }, []);

  const processCallback = async () => {
    try {
      // Troca o code pelo token
      await handleOAuthCallback();

      // Busca o perfil para salvar o ID do usuario
      await getProfile();

      setStatus('success');
      setMessage('Conta LinkedIn conectada com sucesso! Voce ja pode fechar esta janela.');

      // Se for um popup, avisa a janela pai e fecha
      if (window.opener) {
        window.opener.postMessage({ type: 'linkedin_auth_success' }, '*');
        setTimeout(() => window.close(), 2000);
      }
    } catch (error) {
      console.error('Erro no callback do LinkedIn:', error);
      setStatus('error');
      setMessage(error.message || 'Erro ao conectar com o LinkedIn. Tente novamente.');
    }
  };

  const handleClose = () => {
    if (window.opener) {
      window.close();
    } else {
      window.location.href = '/admin/blog';
    }
  };

  const getIcon = () => {
    if (status === 'loading') return <FaSpinner />;
    if (status === 'success') return <FaCheckCircle />;
    if (status === 'error') return <FaTimesCircle />;
    return <FaLinkedin />;
  };

  const getTitle = () => {
    if (status === 'loading') return 'Conectando...';
    if (status === 'success') return 'Conectado!';
    if (status === 'error') return 'Erro na Conexao';
    return 'LinkedIn';
  };

  return (
    <Container>
      <Card>
        <Icon $status={status} $loading={status === 'loading'}>
          {getIcon()}
        </Icon>
        <Title>{getTitle()}</Title>
        <Message>{message}</Message>
        {status !== 'loading' && (
          <CloseButton onClick={handleClose}>
            {status === 'success' ? 'Fechar' : 'Tentar Novamente'}
          </CloseButton>
        )}
      </Card>
    </Container>
  );
};

export default LinkedInCallback;
